import React from 'react'
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { DateCellStyling,ContainerStyling,HeadingStyling,ContentCellStyling,TableStyling,TableRowStyling } from './BiogTableStyles';

export default function BiogProfExperience() {
  const { t } = useTranslation('common');

  return (
    <Grid2 flexDirection="row" sx={ContainerStyling}>
        <TableContainer>
          <Table sx={TableStyling} aria-label="simple table">
            <TableBody>
              <TableRow
                key={"1"}
                sx={TableRowStyling}
              >
                <TableCell component="td" padding="none" scope="row" sx={DateCellStyling}>
                2001-
                </TableCell>
                <TableCell align="left" padding="none" sx={ContentCellStyling}>
                  <Box sx={{fontWeight : 'bold'}} component='span'>{"Selbstständige Kunsttherapeutin"}</Box>
                  <Box sx={{fontWeight : 'normal'}} component='span'>, Basel</Box>
                </TableCell>
              </TableRow>
              <TableRow
                key={"2"}
                sx={TableRowStyling}
              >
                <TableCell component="td" padding="none" scope="row" sx={DateCellStyling}>
                2000
                </TableCell>
                <TableCell align="left" padding="none" sx={ContentCellStyling}>
                  <Box sx={{fontWeight : 'bold'}} component='span'>{"Kunsttherapie"}</Box>
                  <Box sx={{fontWeight : 'normal'}} component='span'>, Psychiatrische Klinik am Kantonsspital Luzern</Box>
                </TableCell>
              </TableRow>
              <TableRow
                key={"3"}
                sx={TableRowStyling}
              >
                <TableCell component="td" padding="none" scope="row" sx={DateCellStyling}>
                1998/99
                </TableCell>
                <TableCell align="left" padding="none" sx={ContentCellStyling}>
                  <Box sx={{fontWeight : 'bold'}} component='span'>{"Kunsttherapie"}</Box>
                  <Box sx={{fontWeight : 'normal'}} component='span'>, Psychotherapeutische Tagesklinik, Basel</Box>
                </TableCell>
              </TableRow>
              <TableRow
                key={"4"}
                sx={TableRowStyling}
              >
                <TableCell component="td" padding="none" scope="row" sx={DateCellStyling}>
                1997/98
                </TableCell>
                <TableCell align="left" padding="none" sx={ContentCellStyling}>
                  <Box sx={{fontWeight : 'bold'}} component='span'>{"Kunst-, Musik- und Tanztherapie"}</Box>
                  <Box sx={{fontWeight : 'normal'}} component='span'>, Rehaklinik, Rheinfelden</Box>
                </TableCell>
              </TableRow>
              <TableRow
                key={"5"}
                sx={TableRowStyling}
              >
                <TableCell component="td" padding="none" scope="row" sx={DateCellStyling}>
                1984-87
                </TableCell>
                <TableCell align="left" padding="none" sx={ContentCellStyling}>
                  <Box sx={{fontWeight : 'bold'}} component='span'>{"Mitarbeit"}</Box>
                  <Box sx={{fontWeight : 'normal'}} component='span'> mit Künstlerin Ina Kozel an grossen Kunstaufträgen, Oakland, CA</Box>
                </TableCell>
              </TableRow>
              <TableRow
                key={"6"}
                sx={TableRowStyling}
              >
                <TableCell component="td" padding="none" scope="row" sx={DateCellStyling}>
                1978-79/82
                </TableCell>
                <TableCell align="left" padding="none" sx={ContentCellStyling}>
                  <Box sx={{fontWeight : 'bold'}} component='span'>{"Selbständige Architektin"}</Box>
                  <Box sx={{fontWeight : 'normal'}} component='span'>, Zürich und Basel</Box>
                </TableCell>
              </TableRow>
              <TableRow
                key={"7"}
                sx={TableRowStyling}
              >
                <TableCell component="td" padding="none" scope="row" sx={DateCellStyling}>
                1980-81
                </TableCell>
                <TableCell align="left" padding="none" sx={ContentCellStyling}>
                  <Box sx={{fontWeight : 'bold'}} component='span'>{"Architektin und Geschäftsleitungsmitglied"}</Box>
                  <Box sx={{fontWeight : 'normal'}} component='span'>, Metron Architektur und Planung, Brugg</Box>
                </TableCell>
              </TableRow>
              <TableRow
                key={"8"}
                sx={TableRowStyling}
              >
                <TableCell component="td" padding="none" scope="row" sx={DateCellStyling}>
                1979
                </TableCell>
                <TableCell align="left" padding="none" sx={ContentCellStyling}>
                  <Box sx={{fontWeight : 'bold'}} component='span'>{"Innenarchitektin und Architektin"}</Box>
                  <Box sx={{fontWeight : 'normal'}} component='span'>, Zimmermann, Architektur, Zürich</Box>
                </TableCell>
              </TableRow>
              <TableRow
                key={"9"}
                sx={TableRowStyling}
              >
                <TableCell component="td" padding="none" scope="row" sx={DateCellStyling}>
                1971
                </TableCell>
                <TableCell align="left" padding="none" sx={ContentCellStyling}>
                  <Box sx={{fontWeight : 'bold'}} component='span'>{"Architekturpraktikantin"}</Box>
                  <Box sx={{fontWeight : 'normal'}} component='span'>, Burckhardt Architekten, Basel</Box>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
    </Grid2>
  )
}
